// @flow
import React from 'react';
import Routes from './routes/Routes';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { UserProvider } from './contexts/UserContext';
import { SelectedFacilitiesProvider } from './contexts/SelectedFacilitiesContext';
import { RxNowUnreadProvider } from './contexts/RxNowUnreadContext';

// setup fake backend
import { configureFakeBackend } from './helpers';

// Themes
import './assets/scss/Saas.scss';
import { Router } from 'react-router-dom';
import axios from 'axios';
import IdleTimerContainer from './utility-components/IdleTimerContainer';
import { ActiveAlertProvider } from './contexts/ActiveAlertContext';
import { CurrentTimeProvider } from './contexts/CurrentTimeContext';
import { SingleWidgetActiveTabProvider } from './contexts/SingleWidgetActiveTabContext';
import { AlertSearchProvider } from './contexts/AlertSearchContext';
import { ShowResolvedAlertsProvider } from './contexts/ShowResolvedAlertsContexts';
import { ShowAllFacilitiesProvider } from './contexts/ShowAllFacilitiesContext';
import { UserRolesProvider } from './contexts/UserRolesContext';
import { LogrocketProvider } from './logrocketSetup';
import { SelectedPharmaciesProvider } from './contexts/SelectedPharmaciesContext';
import NavigationActivityTracker from './components/NavigationActivityTracker';
import { history } from './sentry';

// For Dark import Saas-Dark.scss
// import './assets/scss/Saas-Dark.scss';

// For Modern import Modern.scss
// import './assets/scss/Modern.scss';
// For modern dakr import Modern-Dark.scss
// import './assets/scss/Modern-Dark.scss';

// For Creative demo import Modern.scss
// import './assets/scss/Creative.scss';
// For Creative dark demo import Modern.scss
// import './assets/scss/Creative-Dark.scss';

// configure fake backend
// configureFakeBackend();

import useMediprocityUnreadMessages from './custom-hooks/useMediprocityUnreadMessages';

// Create a client for React Query
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 5 * 60 * 1000, // 5 minutes
        },
    },
});

const ContextProviders = (props) => {
    return(
        <UserProvider>
            <RxNowUnreadProvider>
                <ShowResolvedAlertsProvider>
                <ShowAllFacilitiesProvider>
                    <CurrentTimeProvider>
                        <ActiveAlertProvider>
                            <SingleWidgetActiveTabProvider>
                                <AlertSearchProvider>
                                <SelectedPharmaciesProvider>
                                    <SelectedFacilitiesProvider>
                                        <UserRolesProvider>
                                            <LogrocketProvider>
                                                <MediprocityInitializer>
                                                    {props.children}
                                                </MediprocityInitializer>
                                            </LogrocketProvider>
                                        </UserRolesProvider>
                                    </SelectedFacilitiesProvider>
                                </SelectedPharmaciesProvider>
                                </AlertSearchProvider>
                            </SingleWidgetActiveTabProvider>
                        </ActiveAlertProvider>
                    </CurrentTimeProvider>
                </ShowAllFacilitiesProvider>
                </ShowResolvedAlertsProvider>
            </RxNowUnreadProvider>
        </UserProvider>  
    )
}

/**
 * Component to initialize Mediprocity inside the context tree
 * This ensures access to all required contexts
 */
const MediprocityInitializer = ({ children }) => {
    console.log('🔧 MediprocityInitializer component rendered');
    useMediprocityUnreadMessages();
    return children;
}

/**
 * Main app component
 */
const  App = () =>  {

    // axios.interceptors.response.use(function (response) {
    //     // Any status code that lie within the range of 2xx cause this function to trigger
    //     // Do something with response data

    //     return response;
    //   }, function (error) {
    //     // Any status codes that falls outside the range of 2xx cause this function to trigger
    //     // Do something with response error
    //     toast.error(`${error.response.status}: ${error.response.data.errors[0].msg}`)

    //     return Promise.reject(error);
    //   });

    return (
        <QueryClientProvider client={queryClient}>
            <Router
                history={history}
            // basename='/srx/faci'
            >
                {/* Hidden container for Mediprocity widget */}
                <div id="mediprocity-hidden-container" style={{ display: "none" }} />
                <ContextProviders>
                    <NavigationActivityTracker />
                    <Routes></Routes>
                    <IdleTimerContainer />
                    <ToastContainer
                        position="bottom-right"
                        theme="light"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        icon
                        draggable
                        pauseOnHover
                    />
                </ContextProviders>
            </Router>
        </QueryClientProvider>
    )
}

export default App;
